export const ADD_PERMISSIONS = 'ADD_PERMISSIONS'
export const SET_SHOP_PERMISSIONS = 'SET_SHOP_PERMISSIONS'
export const SET_CONTEXT_SHOP = 'SET_CONTEXT_SHOP'
export const SET_PERMISSION_LABELS = 'SET_PERMISSION_LABELS'


